import StuTrArea from "./row";
import styles from "./index.module.css";

function StuListArea(props: any) {
  let myProps = {
    info_arr: [],
    xColumnArr: {},
    open_study_result_popup: (inData: any) => { },
    ...props
  };

  const get_stu_tr_tags = () => {
    let tr_tags: any = myProps.info_arr.map((info: any, idx: number) => {
      return (
        <StuTrArea
          key={idx}
          row_num={idx}
          info={info}
          xColumnArr={myProps.xColumnArr}
          open_study_result_popup={myProps.open_study_result_popup}
        />
      );
    });
    return tr_tags;
  };

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <colgroup>
          <col width={"60px"}></col>
          {myProps.xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
            return (
              <col key={idx} width={col.width}></col>
            );
          })}
        </colgroup>
        <thead>
          <tr>
            <th>No</th>
            {myProps.xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
              return (
                <th key={idx}>{col.name}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {myProps.info_arr.length > 0 ? (
            get_stu_tr_tags()
          ) : (
            <tr>
              <td colSpan={myProps.xColumnArr.x_column_list_arr.length + 1} className={styles.noData}>
                학생 데이터가 없습니다
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
export default StuListArea;